import type { ViewsRestrictions } from '@/entities/session';
import { ViewAccessType } from '@/entities/session';

export const getViewsRestrictionsCount = (
  viewsRestrictions: ViewsRestrictions,
) => {
  return Object.values(viewsRestrictions).filter(
    (access) => access === ViewAccessType.DENIED,
  ).length;
};
